import { OverlayModule } from "@angular/cdk/overlay";
import { NgModule } from "@angular/core";
import { CommonModule } from "common";
import { MonthYearPickerComponent } from "./month-year-picker/month-year-picker.component";
import { RequestStatementDialogComponent } from "./request-statement-dialog.component";

// Shared so both the loan-level (DocumentModule) and entity-level (EntityDocumentsModule) documents pages
// can open the statement dialog. CommonModule (barrel) supplies Material + reactive forms; OverlayModule
// backs the month/year picker popup.
@NgModule({
  imports: [CommonModule, OverlayModule],
  declarations: [RequestStatementDialogComponent, MonthYearPickerComponent],
  exports: [RequestStatementDialogComponent, MonthYearPickerComponent],
})
export class RequestStatementDialogModule {}
